import { matchRoutes, useLocation, useNavigate } from 'react-router-dom';
import accountIcon from '@web/utils/src/assets/icons/functions/account-icon.svg';
import { Cart, CartButton } from '../Cart';
import { Logo } from '../Logo';

const dissallowCartRoutes = [
  { path: '/order/:orderId/success' },
  { path: '/' },
];

const MobileNavigation = () => {
  const location = useLocation();
  const cartAllowedRoutes = matchRoutes(dissallowCartRoutes, location);
  const navigate = useNavigate();

  return (
    <nav
      id="mobile-nav"
      className="flex md:hidden h-14-0 w-full justify-between items-center container bg-primary-white shadow-sm relative"
    >
      <div className="space-y-0-5" onClick={() => navigate('/')}>
        <span className="block w-4-0 h-0-3 bg-primary-black rounded-base"></span>
        <span className="block w-4-0 h-0-3 bg-primary-black rounded-base"></span>
        <span className="block w-4-0 h-0-3 bg-primary-black rounded-base"></span>
      </div>

      <div onClick={() => navigate('/')}>
        <Logo className="h-5-0" />
      </div>

      <div className="flex gap-3-0 items-center">
        <div className="p-2-0">
          <img src={accountIcon} />
        </div>
        {!cartAllowedRoutes && <CartButton />}
      </div>
      <Cart />
    </nav>
  );
};

export default MobileNavigation;
